export enum WallboxConnectionType {
  LOCAL_REST = 'local-rest',
  LOCAL_UDP = 'local-udp',
  LOCAL_BLE = 'local-ble',
  REMOTE = 'remote',
}
